export default __webpack_public_path__ + "static/media/TriciaSerres.b4afeb9e.jpg";